import { SALE_LOT as SALE_LOT_ACTION_TYPES } from "constants/actionTypes";

export enum BulkUpdateModel {
  SALE_LOT = "salelot",
  SALE_LOT_SERIALIZER = "salelot-serializer",
  AUCTION_PEN = "auctionpen",
  BILLING_DOCUMENT = "billingdocument",
  MLA_SUPPLEMENTARY_DATA = "mla-supplementary-data",
  BUSINESS = "business",
}

export const BulkUpdateModelActions = {
  [BulkUpdateModel.SALE_LOT]: SALE_LOT_ACTION_TYPES.UPDATE_BULK,
  [BulkUpdateModel.SALE_LOT_SERIALIZER]: SALE_LOT_ACTION_TYPES.UPDATE_BULK,
};
